import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import CustomCard from "Components/Card";

const StepThree = ({ entity }) => {
    const { messages } = useIntl();

    const {
        allCameras,
        groupingSelectedCameras,
        groupingByHarwareVersion,
    } = useSelector((state) => state.assignFirmwareDeviceRedux);

    // Map entity ID to corresponding data
    const entityDataMap = {
        all: allCameras,
        hardwareVersion: groupingByHarwareVersion,
        entities: groupingSelectedCameras,
    };

    // Generic render function for cards
    const renderCard = (item, index) => (
        <CustomCard key={index} hideButton>
            <div style={{ display: "grid" }}>
                <div>
                    <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['assign_firmware_device_model']}</label>
                    <span>{item?.deviceModel}</span>
                </div>
                <div>
                    <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['assign_firmware_hardware_version']}</label>
                    <span>{item?.hardwareVersion}</span>
                </div>
                <div>
                    <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['assign_firmware_devices']}</label>
                    <span>{item?.items?.length}</span>
                </div>
                <div>
                    <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['assign_firmware_new_Firmware']}</label>
                    <span>{item?.newFirmware?.label}</span>
                </div>
            </div>
        </CustomCard>
    );

    const dataToRender = entityDataMap[entity?.id] || [];

    return <div>{dataToRender.map(renderCard)}</div>;
};

export default StepThree;
